<template>
    <div class="col-lg-11 col-11 mx-auto">
        <div class="card card-widget widget-user">
            <div class="widget-user-header text-white"
            style="background: url('/assets/images/pexels-francesco-ungaro-2325446_balloons_timeline.png')  center;">
                <h2 class="widget-user-desc text-left">Watch Yourself Grow/Evolve to Better</h2>
                <!-- <h2 class="widget-user-desc text-left">Even as the years go by.</h2> -->
                <h4 class="widget-user-desc text-right">Version 2.0 of You</h4>
                <h4 class="widget-user-username text-right">Surpass Yesterday</h4>
            </div>
            <div class="widget-user-image">
                <img class="img-circle" src="/assets/images/pexels-brett-sayles-3027216_balloons128x128.png" alt="User Avatar">
            </div>
        </div>

        <div class="row d-flex justify-content-between">
                <h4 class="col-4" v-if="timeslicesdata.length<1">Your Time-Slices will appear below</h4>
 <h4 class="col-4" v-if="timeslicesdata.length>0">Your Time-Slices:</h4>
                <a @click="showVideoModal()" class="btn btn-sm col-2"><i class="fas fa-tv"></i> Info</a>
                <a @click="showCreateModal()" class="btn btn-sm col-2"><i class="fas fa-plus"></i> Add a Time-Slice of You</a>
        </div>
        <div class="list-group-item">
                <div class="row">
                    <div v-for="aSlice in timeslicesdata"  :key="aSlice.id" class="col-auto col-md-4">
                        <div class="content-box-gray card" >
                        <div class="title text-center d-flex">
                            <h6 class="mt-2" style="margin:auto;" v-html="aSlice.headline"></h6>
                            <a @click="deleteSlice(aSlice.id)" title="Delete" class="btn btn-sm col-2">
                                <i class="fas fa-trash fai-red"></i>
                            </a>
                        </div>
                            <div class="content">
                            <img v-if="aSlice.visual_option=='image'" style="width:100%;" :src="getFilePath(aSlice.image.file_path)"/>
                             <iframe  v-if="aSlice.visual_option=='video'" id="aSlice.id" :src="aSlice.videourl" width="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            <div class="card" style="padding:.5em;">
                                    <h4>{{aSlice.headline}}<h6> @({{aSlice.created_at}})</h6></h4>
                                    <div class="row d-flex justify-content-between">
                                    <h5 class="col-6">Story:</h5>
                                    <p v-html="aSlice.text"></p>
                                    </div>
                                    <div class="d-flex flex-row justify-content-end">
                                </div>
                                <div class="card bg-secondary mb-1">
                                <table><tr><td  style="text-align:center;font-size:.8em;" colspan="3">TimeSlice Visibility:</td></tr>
                                    <tr><td style="text-align:center;" v-for="item in visibilities" :key='item'>
                                            <label class="radiolabel" :for="item"> {{item}}<br/>
                                                <input @change="recordVisibilityChange(aSlice.id, item)" type="radio" :id="item" v-model="aSlice.visibility" :value="item" >
                                            </label>
                                        </td>
                                        <td style="border:.5px solid #fff;">
                                            <label class="savelabel" >Save<br/>
                                                <i @click="saveVisiblityChange(aSlice.id)" title="Confirm &amp; Save" class="fas fa-save fai-white bg-primary"></i>
                                            </label>
                                        </td>
                                    </tr></table>
                                </div>

                            </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';


export default {
    components: { Errors },
    name: "ShowofForumHome",
    data() {
        return {
        userdata:[],
        timeslicesdata:[],
        errors: {
                nahme: '',
                message: '',
                },
        visibilities: ['private', 'community', 'world'],
        videoData:'',
        video:'',
        videoSrc:'',
        videoDuration:'',
        thisComponentName:'',
        }
    },
    props: {
        user:'',
        apikey:'',
        timeslices:'',
        videos:'',


    },
    mounted() {
        this.thisComponentName = this.$options.name;
        this.userdata = JSON.parse(this.user);
        this.timeslicesdata = JSON.parse(this.timeslices);
        this.videoData = JSON.parse(this.videos);
        this.setupVideo();
        EventBus.$on('refreshShowofforumHome', (data) => {
            this.refreshPage();

        });
    },

    methods: {
        setupVideo() {
            const siteVideoName = this.thisComponentName + "_video";
            console.log(`Looking for ${siteVideoName}`);
            this.videoData.forEach(video => {
                const videoName = video.name;
                const vidUrl = video.url;
                const vidDuration = video.duration;
                console.log(`${videoName}, ${vidUrl}, ${vidDuration}`);
                    if(videoName == siteVideoName) {
                        console.log(`Found it: ${videoName}, ${vidUrl}, ${vidDuration}`);
                        this.video = video;
                        this.videoSrc = vidUrl;
                        this.videoDuration = vidDuration;
                    }
            });
        },

        recordVisibilityChange(tsliceID, visibility) {
            console.log("Tslice: " + tsliceID +", visib: " + visibility);
        },
        saveVisiblityChange(tsliceID, visibility) {
            console.log("Tslice: " + tsliceID );
                var tS = this.getTimeSlice(tsliceID);
                console.log("vis:" + tS.visibility);
            axios.post(`/showofforum/timeslice/visibility/`+tsliceID, {visibility:tS.visibility})
            .then(response => {
            if (!response.data.updated) {
                console.error("Unable to update. Please try later");
                 this.updateToast("Unable to update. Please try later", 4000, 'error');
            } else {
               console.log(response);
            //    this.refreshPage();
                this.updateToast(response.data.message, 4000, 'success');
            }
            })
            .catch(err => {
                console.error(err);
            });
        },
        getTimeSlice(id) {
            var tS = '';
            [...this.timeslicesdata].forEach((tx)=>{
                if(tx.id == id) tS = tx;
            });
            return tS;
        },
        getFormattedDate(utcString) {
            return new Date(Date.UTC(utcString));

        },
        deleteSlice(id) {
            this.swalConfirm(id);
        },
        doDeleteSlice(id) {
            console.error("Deleting " +id);
            axios.put(`/showofforum/timeslice/delete/`+id)
            .then(response => {
            if (!response.data.deleted) {
                console.error("Unable to delete. Please try later");
            } else {
               console.log(response);
               this.refreshPage();
            }
            })
            .catch(err => {
                console.error(err);
            });
        },
        getFilePath(filePath) {
            return "/storage/"+ filePath;
        },
        showForum(channel) {
            console.log("Show forum: " + channel);
            window.location.replace('/forum/channels/' + channel.name);
        },
        getIconAndName(channel) {
            return channel.icon + channel.name;

        },
        showCreateModal(){
            console.error('showCreateModal invoked...');
            const payload = {userdata: this.userdata};
            // EventBus.$emit('displayShowOffCreateModal', payload);
EventBus.$emit('displayShowOffMinifyCreateModal', payload);

        },
        showVideoModal(){
            const payload = {title:"Why a Time-Slice, when we can post on 100's of other Social Media sites?",
            videourl: this.videoSrc,
            displayText: this.videoText};
            EventBus.$emit('displayVideoModal', payload);
        },
        refreshPage(){
            window.location.reload();
        },
        swalConfirm(id) {
             Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // setTimeout( function (id) {
                    //     this.doDeleteSlice(id);
                    // }, 3000);
                    this.doDeleteSlice(id);
                    Swal.fire(
                        'Deletion in progress!',
                        '',
                        'success'
                    );
                }
            });
        },
    updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    },
    computed:{
        videoText() {
            var retval =  "<div><small><p>Record a time-slice of yourself, about yourself, as you are today.</p>";
            retval +=  "<p>But not just any time-slice.  This one is about <b>you</b>, at the exact time when you are ready to accept the challenge: to grow and evolve yourself to the next level,";
            retval +=  "(whatever that may mean for <em>you</em>).</p> ";
            retval +=  "<p>These Time-Slice records will help you stay focussed, to strive, and therefore, deliver a Better You, to you, <em>for</em> you.</p>";
            retval +=  "<p>And in here, in your own private space, you will be able to <u>actually track your progress</u>, Time-Slice by Time-Slice.";
            retval +=  "<p>(Instead of digging through all the confusion and crowding on social posts)";
            retval +=  "<br/><br/><b>Note:</b>This is your own private journey, to the next Version of you.</p>";
            retval +=  "<p>(Maybe, one day, you may want to show this to others, to \"go public\" with your journey, your growth, your successes, ... who knows?)";
            retval +=  "<br/><br/>But for now, focus on (and enjoy), your private adventure and challenge. (Perhaps, best of all, only you know your challenge/s).</p><p>Go ahead, now.  Create your Time-Slice.</p></small></div>";
            return retval;
        }
    }


}
</script>

<style scoped>

.radiolabel{
    /* display:inline-block; */
    font-size: .5em;
    font-weight: 400 !important;
}
.savelabel{
    /* display:inline-block; */
    font-size: .7em;
    font-weight: 400 !important;
    text-align:center;
}
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:3px solid #fff;
    background: rgb(209, 219, 248);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:rgb(18, 7, 240);
}
.fai-orange{
    color:rgb(230, 111, 13);
}
.fai-white{
    color:rgb(255, 255, 255);
}


.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}

.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#5fa3ca;
    font-size:.75em;
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}







</style>
